import { keyBy } from "lodash";

import {
  IEntityDeleteSuccess,
  IEntityFetchCollectionSuccess,
  IEntityFetchSuccess,
  IEntityUpdateSuccess,
} from "store/entities/actions";
import { CustomViewsAction, CustomViewsActionsNames } from "store/entities/custom-views/actions";
import { ICustomView } from "store/entities/custom-views/interfaces";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "store/entities/reducer";

const initialState = {
  data: {},
  order: [],
};

export interface ICustomViewState {
  data: IEntityCollectionState<ICustomView>;
  order: string[];
}

export const customViewsReducer = (
  state: ICustomViewState = initialState,
  action: CustomViewsAction
): ICustomViewState => {
  switch (action.type) {
    case CustomViewsActionsNames.FETCH_SINGLE.SUCCESS: {
      const { value: view } = action.payload as IEntityFetchSuccess<ICustomView>;

      const viewExists = state.data[view.id] !== undefined;

      return {
        data: {
          ...state.data,
          [view.id]: view,
        },
        order: viewExists ? state.order : [...state.order, view.id],
      };
    }

    case CustomViewsActionsNames.FETCH_COLLECTION.SUCCESS: {
      const { values } = action.payload as IEntityFetchCollectionSuccess<ICustomView>;
      return { data: keyBy(values, v => v.id), order: values.map(view => view.id) };
    }

    case CustomViewsActionsNames.CREATE.SUCCESS:
    case CustomViewsActionsNames.UPDATE.SUCCESS: {
      const { value: customView } = action.payload as IEntityUpdateSuccess<ICustomView>;
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      const viewExists = state.data[customView.id] !== undefined;

      return {
        // @ts-expect-error TS(2322): Type '{ [x: string]: ICustomView | undefined; }' i... Remove this comment to see the full error message
        data: {
          ...state.data,
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          [customView.id]: customView,
        },
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        order: viewExists ? state.order : [...state.order, customView.id],
      };
    }

    case CustomViewsActionsNames.DELETE.SUCCESS:
    case CustomViewsActionsNames.SYNC_DELETE: {
      const { id } = action.payload as IEntityDeleteSuccess;
      // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      const orderIndex = state.order.indexOf(id);

      // @ts-expect-error TS(2464): A computed property name must be of type 'string',... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [id]: toDelete, ...restState } = state.data;
      return {
        data: restState,
        order:
          orderIndex !== -1 ? [...state.order.slice(0, orderIndex), ...state.order.slice(orderIndex + 1)] : state.order,
      };
    }

    default:
      return state;
  }
};
